module.exports = __webpack_public_path__ + "img/plus-filled.75f63dc6.svg";